import { Field, Form, FormikProps } from 'formik';
import * as React from 'react';

import { EMPTY_STRING } from './Constants';

export interface IFormValues {
  accountNumber: string;
  accountType: string;
  email: string;
  ssnLastFour: string;
  userName: string;
}

function showChooseOne(accountType?: string) {
  if (accountType === EMPTY_STRING || accountType === undefined) {
    return <option value={EMPTY_STRING}>Choose One</option>;
  }
  return;
}

function showErrorDiv(error: string, touched: boolean) {
  return (
    <div
      style={
        touched && error
          ? {
            background: 'rgb(255, 255, 255)',
            boxShadow: 'rgb(124, 124, 124) 0px 0px 1px 0px',
            color: 'rgb(211, 47, 47)',
            fontSize: '0.75rem',
            padding: '5px'
          }
          : { display: 'none !important' }
      }
      className="field-error default align-items-center"
      role="alert"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="exclamation-circle"
        className="svg-inline--fa fa-exclamation-circle"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        color=""
      >
        <path
          fill="currentColor"
          d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"
        />
      </svg>
      {error}
    </div>
  );
}

// tslint:disable: jsx-no-lambda
export const InlineForm = ({ errors, handleBlur, handleChange, handleSubmit, touched, values }: FormikProps<IFormValues>) => (
  <Form className="enrollment-form">
    <div className="challenge-controls">
      <div className="form-group">
        <label
          id="ssnLastFourLabel"
          className={touched.ssnLastFour && errors.ssnLastFour ? 'error' : EMPTY_STRING}
        >
          Last Four of SSN
        </label>
        <br />
        <Field
          type="text"
          name="ssnLastFour"
          placeholder="####"
          value={values.ssnLastFour}
          className={touched.ssnLastFour && errors.ssnLastFour ? 'error' : EMPTY_STRING}
          size={74}
          maxLength={4}
        />
        {touched.ssnLastFour && errors.ssnLastFour ? (
          showErrorDiv(errors.ssnLastFour, touched.ssnLastFour)
        ) : (
            <div />
          )}
      </div>
      <div className="form-group">
        <label
          id="accountTypeLabel"
          className={touched.accountType && errors.accountType ? 'error' : EMPTY_STRING}
        >
          Account Type
        </label>
        <br />
        <Field
          component="select"
          name="accountType"
          default={values.accountType}
          className={(touched.accountType && errors.accountType ? 'select-error' : EMPTY_STRING)}
          style={{ color: touched.accountType ? 'rgb(0, 0, 0)' : 'rgb(127, 127, 127)' }}
        >
          {showChooseOne(values.accountType)}
          <option value={'DEMAND'}>CHECKING</option>
          <option value={'LOAN'}>LOAN</option>
          <option value={'SAVINGS'}>SAVINGS</option>
          <option value={'TIME'}>CD</option>
        </Field>
        {touched.accountType && errors.accountType ? (
          showErrorDiv(errors.accountType, touched.accountType)
        ) : (
            <div />
          )}
      </div>
      <div className="form-group">
        <label
          id="accountNumberLabel"
          className={touched.accountNumber && errors.accountNumber ? 'error' : EMPTY_STRING}
        >
          Account Number
        </label>
        <br />
        <Field
          type="text"
          name="accountNumber"
          placeholder="Account Number"
          value={values.accountNumber}
          className={touched.accountNumber && errors.accountNumber ? 'error' : EMPTY_STRING}
          size={74}
          maxLength={11}
        />
        {touched.accountNumber && errors.accountNumber ? (
          showErrorDiv(errors.accountNumber, touched.accountNumber)
        ) : (
            <div />
          )}
      </div>
      <div className="form-group">
        <label id="emailLabel" className={touched.email && errors.email ? 'error' : EMPTY_STRING}>
          Email Address
        </label>
        <br />
        <Field
          type="text"
          name="email"
          placeholder="email@domain.net"
          value={values.email}
          className={touched.email && errors.email ? 'error' : EMPTY_STRING}
          size={74}
          maxLength={100}
        />
        {touched.email && errors.email ? (
          showErrorDiv(errors.email, touched.email)
        ) : (
            <div />
          )}
      </div>
      <div className="form-group">
        <label
          id="userNameLabel"
          className={touched.userName && errors.userName ? 'error' : EMPTY_STRING}
        >
          User Name
        </label>
        <br />
        <Field
          type="text"
          name="userName"
          placeholder="User Name"
          value={values.userName}
          className={touched.userName && errors.userName ? 'error' : EMPTY_STRING}
          size={74}
          minLength={8}
          maxLength={20}
        />
        {touched.userName && errors.userName ? (
          showErrorDiv(errors.userName, touched.userName)
        ) : (
            <div />
          )}
      </div>
    </div>
    <div className="detail-btn-group">
      <Field
        component="button"
        name="submit"
        type="submit"
        className="btn btn-default btn-submit primary"
        onClick={handleSubmit}
      >
        Submit
      </Field>
    </div>
  </Form>
);



// WEBPACK FOOTER //
// ./src/UserEnrollmentForm.tsx